import { listDailyErrors, updateDailyReportItem } from '../api/gatewise_api';

export const deps = {
  listDailyErrors,
  updateDailyReportItem,
};
